var _defs, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    zoomAndPan: "magnify",
    viewBox: "0 0 187.5 187.499992",
    height: 250,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "66d73b0a6a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.316406 9.316406 L 177.617188 9.316406 L 177.617188 177.617188 L 9.316406 177.617188 Z M 9.316406 9.316406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "58b661ec0a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116 148 L 155.09375 148 L 155.09375 162 L 116 162 Z M 116 148 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "46827245b5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116 137 L 155.09375 137 L 155.09375 152 L 116 152 Z M 116 137 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c5e2f41b52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116 126 L 155.09375 126 L 155.09375 141 L 116 141 Z M 116 126 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "017b843d20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116 116 L 155.09375 116 L 155.09375 131 L 116 131 Z M 116 116 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0da2e4f2d0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116 106 L 155.09375 106 L 155.09375 120 L 116 120 Z M 116 106 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eea989012e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116 95 L 155.09375 95 L 155.09375 110 L 116 110 Z M 116 95 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d6311cd4c7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116 86 L 155.09375 86 L 155.09375 100 L 116 100 Z M 116 86 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "567f2df448"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116 70.027344 L 155.09375 70.027344 L 155.09375 90 L 116 90 Z M 116 70.027344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "45ea30a5cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.671875 148 L 71 148 L 71 162 L 31.671875 162 Z M 31.671875 148 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ec57963e3c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.671875 137 L 71 137 L 71 152 L 31.671875 152 Z M 31.671875 137 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d7d77008fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.671875 112 L 71 112 L 71 133 L 31.671875 133 Z M 31.671875 112 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "913efa6cfa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.671875 128 L 71 128 L 71 142 L 31.671875 142 Z M 31.671875 128 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3a85b45cc8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37 54 L 57 54 L 57 84 L 37 84 Z M 37 54 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc5ec393ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 83.707031 49.898438 L 86.410156 86.449219 L 37.921875 90.035156 L 35.21875 53.484375 Z M 83.707031 49.898438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "105532542c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34.855469 53.511719 L 37.558594 90.0625 L 86.046875 86.476562 L 83.34375 49.925781 Z M 34.855469 53.511719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "da26110eaa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49 52 L 86 52 L 86 88 L 49 88 Z M 49 52 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8d9e51d36c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 83.707031 49.898438 L 86.410156 86.449219 L 37.921875 90.035156 L 35.21875 53.484375 Z M 83.707031 49.898438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d5acc0316b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34.855469 53.511719 L 37.558594 90.0625 L 86.046875 86.476562 L 83.34375 49.925781 Z M 34.855469 53.511719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f677e3fd7f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93 31 L 112 31 L 112 62 L 93 62 Z M 93 31 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ee9793fbb2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 138.476562 25.058594 L 143.242188 61.398438 L 95.035156 67.722656 L 90.269531 31.378906 Z M 138.476562 25.058594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2073a2700b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 89.910156 31.425781 L 94.675781 67.769531 L 142.882812 61.445312 L 138.117188 25.105469 Z M 89.910156 31.425781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bed51c2af6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 104 28 L 142 28 L 142 63 L 104 63 Z M 104 28 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ef1736af2d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 138.476562 25.058594 L 143.242188 61.398438 L 95.035156 67.722656 L 90.269531 31.378906 Z M 138.476562 25.058594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5f87348dd4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 89.910156 31.425781 L 94.675781 67.769531 L 142.882812 61.445312 L 138.117188 25.105469 Z M 89.910156 31.425781 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 187 0 L 187 187 L 0 187 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 187 0 L 187 187 L 0 187 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#66d73b0a6a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d8e9d3",
    d: "M 64.5625 177.628906 L 35.964844 177.628906 C 21.28125 177.675781 9.414062 165.808594 9.363281 151.125 C 9.316406 136.445312 21.1875 124.574219 35.867188 124.527344 L 93.210938 124.527344 C 108.464844 124.527344 121 114.230469 123.859375 99.503906 C 124.242188 97.5 124.433594 95.5 124.433594 93.496094 C 124.671875 78.769531 136.351562 67.089844 150.9375 67.042969 C 165.617188 67.421875 177.199219 79.671875 176.820312 94.355469 C 176.4375 108.226562 165.472656 119.476562 151.652344 120.191406 C 145.074219 120.332031 138.972656 121.859375 133.585938 125.625 C 124.765625 131.867188 120.332031 140.449219 120.144531 151.175781 C 120 157.226562 118.285156 162.710938 114.519531 167.429688 C 109.226562 174.101562 102.316406 177.628906 93.734375 177.675781 C 84.011719 177.675781 74.289062 177.628906 64.5625 177.628906 Z M 64.847656 9.507812 C 74.382812 9.507812 83.917969 9.414062 93.402344 9.554688 C 103.886719 9.699219 111.945312 14.324219 116.902344 23.570312 C 121.859375 32.816406 121.382812 41.96875 115.757812 50.691406 C 110.703125 58.460938 103.269531 62.609375 94.019531 62.65625 C 74.574219 62.847656 55.171875 62.847656 35.773438 62.65625 C 21.234375 62.609375 9.414062 50.789062 9.460938 36.25 C 9.460938 36.105469 9.460938 36.011719 9.460938 35.867188 C 9.601562 21.328125 21.28125 9.699219 36.058594 9.554688 C 45.640625 9.460938 55.21875 9.507812 64.847656 9.507812 Z M 177.582031 36.105469 C 177.628906 50.738281 166 62.464844 151.125 62.703125 C 136.253906 62.941406 124.335938 72.429688 121.046875 86.347656 C 120.523438 88.875 120.191406 91.398438 120.144531 93.972656 C 119.761719 108.703125 107.988281 120.285156 93.402344 120.191406 C 78.816406 120.09375 67.042969 108.320312 66.945312 93.734375 C 66.945312 78.957031 78.480469 67.28125 93.355469 66.996094 C 111.085938 66.707031 124.242188 53.550781 124.480469 35.820312 C 124.574219 21.140625 136.492188 9.316406 151.175781 9.414062 C 165.855469 9.507812 177.675781 21.425781 177.582031 36.105469 Z M 124.480469 151.078125 C 124.480469 136.398438 136.351562 124.527344 151.03125 124.527344 C 165.710938 124.527344 177.582031 136.398438 177.582031 151.078125 C 177.582031 165.761719 165.710938 177.628906 151.03125 177.628906 C 151.03125 177.628906 150.984375 177.628906 150.984375 177.628906 C 136.398438 177.675781 124.527344 165.902344 124.480469 151.316406 C 124.480469 151.222656 124.480469 151.175781 124.480469 151.078125 Z M 9.460938 93.496094 C 9.460938 78.53125 21.617188 66.375 36.582031 66.375 C 51.550781 66.375 63.707031 78.53125 63.707031 93.496094 C 63.707031 108.464844 51.550781 120.621094 36.582031 120.621094 C 36.582031 120.621094 36.535156 120.621094 36.535156 120.621094 C 21.617188 120.667969 9.507812 108.558594 9.460938 93.640625 C 9.460938 93.59375 9.460938 93.542969 9.460938 93.496094 Z M 9.460938 93.496094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 73.953125 148.328125 L 73.953125 151.960938 C 73.953125 157.351562 82.917969 161.925781 93.496094 161.925781 C 104.101562 161.925781 113.039062 157.351562 113.039062 151.960938 L 113.039062 148.328125 C 109.113281 152.195312 101.960938 154.773438 93.496094 154.773438 C 85.027344 154.773438 77.847656 152.195312 73.953125 148.328125 Z M 73.953125 148.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 73.953125 137.988281 L 73.953125 141.621094 C 73.953125 147.011719 82.917969 151.582031 93.496094 151.582031 C 104.101562 151.582031 113.039062 147.011719 113.039062 141.621094 L 113.039062 137.988281 C 109.113281 141.855469 101.960938 144.433594 93.496094 144.433594 C 85.027344 144.433594 77.847656 141.855469 73.953125 137.988281 Z M 73.953125 137.988281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 73.953125 127.644531 L 73.953125 131.277344 C 73.953125 136.667969 82.917969 141.238281 93.496094 141.238281 C 104.101562 141.238281 113.039062 136.667969 113.039062 131.277344 L 113.039062 127.644531 C 109.113281 131.511719 101.960938 134.089844 93.496094 134.089844 C 85.027344 134.089844 77.847656 131.511719 73.953125 127.644531 Z M 73.953125 127.644531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 73.953125 117.300781 L 73.953125 120.964844 C 73.953125 126.355469 82.917969 130.925781 93.496094 130.925781 C 104.101562 130.925781 113.039062 126.355469 113.039062 120.964844 L 113.039062 117.332031 C 109.113281 121.199219 101.960938 123.777344 93.496094 123.777344 C 85.027344 123.746094 77.847656 121.167969 73.953125 117.300781 Z M 73.953125 117.300781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 93.496094 91.519531 C 82.886719 91.519531 73.953125 96.089844 73.953125 101.480469 C 73.953125 106.871094 82.917969 111.441406 93.496094 111.441406 C 104.101562 111.441406 113.039062 106.871094 113.039062 101.480469 C 113.039062 96.089844 104.101562 91.519531 93.496094 91.519531 Z M 93.496094 91.519531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 73.953125 108.160156 L 73.953125 110.589844 C 73.953125 115.984375 82.917969 120.554688 93.496094 120.554688 C 104.101562 120.554688 113.039062 115.984375 113.039062 110.589844 L 113.039062 108.160156 C 109.113281 112.027344 101.960938 114.605469 93.496094 114.605469 C 85.027344 114.605469 77.847656 112.054688 73.953125 108.160156 Z M 73.953125 108.160156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#58b661ec0a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 116.230469 148.328125 L 116.230469 151.960938 C 116.230469 157.351562 125.195312 161.925781 135.773438 161.925781 C 146.378906 161.925781 155.316406 157.351562 155.316406 151.960938 L 155.316406 148.328125 C 151.390625 152.195312 144.242188 154.773438 135.773438 154.773438 C 127.304688 154.773438 120.128906 152.195312 116.230469 148.328125 Z M 116.230469 148.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#46827245b5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 116.230469 137.226562 L 116.230469 141.621094 C 116.230469 147.011719 125.195312 151.582031 135.773438 151.582031 C 146.378906 151.582031 155.316406 147.011719 155.316406 141.621094 L 155.316406 137.226562 C 151.390625 141.09375 144.242188 143.671875 135.773438 143.671875 C 127.304688 143.671875 120.128906 141.09375 116.230469 137.226562 Z M 116.230469 137.226562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c5e2f41b52)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 116.230469 126.851562 L 116.230469 130.542969 C 116.230469 135.933594 125.195312 140.507812 135.773438 140.507812 C 146.378906 140.507812 155.316406 135.933594 155.316406 130.542969 L 155.316406 126.851562 C 151.390625 130.71875 144.242188 133.296875 135.773438 133.296875 C 127.304688 133.296875 120.128906 130.71875 116.230469 126.851562 Z M 116.230469 126.851562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#017b843d20)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 116.230469 116.511719 L 116.230469 120.144531 C 116.230469 125.535156 125.195312 130.105469 135.773438 130.105469 C 146.378906 130.105469 155.316406 125.535156 155.316406 120.144531 L 155.316406 116.511719 C 151.390625 120.378906 144.242188 122.957031 135.773438 122.957031 C 127.304688 122.957031 120.128906 120.378906 116.230469 116.511719 Z M 116.230469 116.511719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0da2e4f2d0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 116.230469 106.167969 L 116.230469 109.800781 C 116.230469 115.191406 125.195312 119.761719 135.773438 119.761719 C 146.378906 119.761719 155.316406 115.191406 155.316406 109.800781 L 155.316406 106.167969 C 151.390625 110.035156 144.242188 112.613281 135.773438 112.613281 C 127.304688 112.613281 120.128906 110.035156 116.230469 106.167969 Z M 116.230469 106.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eea989012e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 116.230469 95.824219 L 116.230469 99.457031 C 116.230469 104.847656 125.195312 109.417969 135.773438 109.417969 C 146.378906 109.417969 155.316406 104.847656 155.316406 99.457031 L 155.316406 95.824219 C 151.390625 99.691406 144.242188 102.269531 135.773438 102.269531 C 127.304688 102.269531 120.128906 99.691406 116.230469 95.824219 Z M 116.230469 95.824219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d6311cd4c7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 116.230469 86.683594 L 116.230469 89.113281 C 116.230469 94.507812 125.195312 99.078125 135.773438 99.078125 C 146.378906 99.078125 155.316406 94.507812 155.316406 89.113281 L 155.316406 86.683594 C 151.390625 90.550781 144.242188 93.128906 135.773438 93.128906 C 127.304688 93.128906 120.128906 90.550781 116.230469 86.683594 Z M 116.230469 86.683594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#567f2df448)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 135.773438 89.964844 C 146.378906 89.964844 155.316406 85.394531 155.316406 80.003906 C 155.316406 74.613281 146.351562 70.042969 135.773438 70.042969 C 125.167969 70.042969 116.230469 74.613281 116.230469 80.003906 C 116.230469 85.394531 125.167969 89.964844 135.773438 89.964844 Z M 135.773438 89.964844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#45ea30a5cb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 31.671875 148.300781 L 31.671875 151.933594 C 31.671875 157.324219 40.640625 161.894531 51.214844 161.894531 C 61.824219 161.894531 70.757812 157.324219 70.757812 151.933594 L 70.757812 148.300781 C 66.832031 152.167969 59.683594 154.746094 51.214844 154.746094 C 42.75 154.746094 35.570312 152.167969 31.671875 148.300781 Z M 31.671875 148.300781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ec57963e3c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 31.671875 137.957031 L 31.671875 141.589844 C 31.671875 146.980469 40.640625 151.550781 51.214844 151.550781 C 61.824219 151.550781 70.757812 146.980469 70.757812 141.589844 L 70.757812 137.957031 C 66.832031 141.824219 59.683594 144.402344 51.214844 144.402344 C 42.75 144.402344 35.570312 141.824219 31.671875 137.957031 Z M 31.671875 137.957031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d7d77008fe)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 51.214844 112.144531 C 40.609375 112.144531 31.671875 116.714844 31.671875 122.105469 C 31.671875 127.496094 40.640625 132.066406 51.214844 132.066406 C 61.824219 132.066406 70.757812 127.496094 70.757812 122.105469 C 70.757812 116.714844 61.824219 112.144531 51.214844 112.144531 Z M 51.214844 112.144531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#913efa6cfa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 31.671875 128.816406 L 31.671875 131.246094 C 31.671875 136.636719 40.640625 141.210938 51.214844 141.210938 C 61.824219 141.210938 70.757812 136.636719 70.757812 131.246094 L 70.757812 128.816406 C 66.832031 132.683594 59.683594 135.261719 51.214844 135.261719 C 42.75 135.261719 35.570312 132.683594 31.671875 128.816406 Z M 31.671875 128.816406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3a85b45cc8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc5ec393ab)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#105532542c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 45.582031 83.144531 C 44.75 70.175781 49.511719 58.941406 56.769531 55.386719 C 55.382812 54.945312 53.953125 54.757812 52.503906 54.867188 C 43 55.570312 36.191406 68.464844 37.175781 83.765625 Z M 45.582031 83.144531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#da26110eaa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8d9e51d36c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d5acc0316b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 56.90625 53.863281 C 62.789062 55.945312 67.871094 62.796875 70.371094 71.90625 L 62.933594 72.03125 L 76.667969 87.230469 L 85.167969 71.65625 L 78.910156 71.761719 C 76.464844 62.445312 71.335938 55.402344 65.375 53.261719 L 65.382812 53.257812 C 65.363281 53.25 65.34375 53.246094 65.320312 53.238281 C 64.808594 53.058594 64.289062 52.914062 63.765625 52.808594 C 58.953125 51.710938 53.179688 52.511719 49.570312 53.835938 L 49.542969 53.855469 C 53.074219 52.617188 55.777344 53.511719 56.90625 53.863281 Z M 56.90625 53.863281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f677e3fd7f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ee9793fbb2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2073a2700b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 102.292969 60.40625 C 100.730469 47.507812 104.847656 36.019531 111.894531 32.0625 C 110.484375 31.699219 109.046875 31.59375 107.605469 31.78125 C 98.15625 33.023438 92.089844 46.28125 93.9375 61.503906 Z M 102.292969 60.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bed51c2af6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ef1736af2d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5f87348dd4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242f4e",
    d: "M 111.945312 30.535156 C 117.933594 32.28125 123.394531 38.832031 126.40625 47.785156 L 118.988281 48.332031 L 133.5625 62.730469 L 141.167969 46.699219 L 134.925781 47.160156 C 131.957031 37.996094 126.4375 31.253906 120.367188 29.453125 L 120.371094 29.449219 C 120.351562 29.441406 120.332031 29.4375 120.3125 29.433594 C 119.789062 29.28125 119.261719 29.167969 118.734375 29.089844 C 113.867188 28.265625 108.148438 29.394531 104.621094 30.921875 L 104.59375 30.941406 C 108.050781 29.503906 110.796875 30.246094 111.945312 30.535156 Z M 111.945312 30.535156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCi);
export default __webpack_public_path__ + "static/media/CI.f44749bef8cbd5c1950baa1ca621b9ad.svg";
export { ForwardRef as ReactComponent };